import {StarFilled} from '@ant-design/icons'
import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useComponentNode from '../_COMPONENT/useComponentNode.jsx'
import api from './apiBdlogic.mjs'
import meta from './metaBdlogic.mjs'
import Model from './ModelBdlogic.mjs'
import getRuleType from './RuleType.jsx'
import PropertiesPane from './PropertiesPaneBdlogic.jsx'
import PropertiesPaneBatch from './PropertiesPaneBatchBdlogic.jsx'
import FormChoose from './FormChooseBdlogic.jsx'
import TableChoose from './TableChooseBdlogic.jsx'

const DEFAULT_RESUME = '在此录入简述'

const getRuleTypes = map => {
    const RuleType = getRuleType(map)

    return new Map(
        RuleType.map(
            ([type, name, icon]) => [type, {icon, name, type}]
        )
    )
}

export default () => {
    const ComponentNode = useComponentNode()

    return extendNode(ComponentNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
        Model,
        PropertiesPane,
        PropertiesPaneBatch,

        attrNodes: {
            top: ['ATTR_BDLOGIC_RESUME'],
        },

        canMountType(map, node, type) {
            return (
                /^(AR|DOC|PIC|URL)$/.test(type) ||
                ComponentNode.canMountType.call(this, map, node, type)
            )
        },

        getDesc(map, node) {
            const {ruleType} = node.data

            if (! ruleType) {
                return this.typeName(map, node.parent)
            }

            const ruleTypes = getRuleTypes(map)
            const {name = ''} = ruleTypes.get(ruleType) ?? {}
            return name
        },

        getIcons(map, node) {
            const icons = []

            const {ruleStar, ruleType} = node.data

            if ('1' === ruleStar) {
                icons.push(<StarFilled style={{color: '#ff4d4f'}} />)
            }

            const ruleTypes = getRuleTypes(map)
            const {icon} = ruleTypes.get(ruleType) ?? {}

            if (icon) {
                icons.push(icon)
            }

            return icons
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'AR'},
                {type: 'PIC'},
                {type: 'DOC'},
                {type: 'URL'},
            ]
        },

        typeName(map, parent) {
            const {subTypeCode} = map.data

            if ('BODA1' === subTypeCode) {
                return this.name
            }
            else {
                return '程序能力'
            }
        },

        async _atOwnerPush(map, node, event) {
            const d = await this._getPushData(map, node)
            event.detail.ruleList.push(d)
        },

        _getCategories(map, node) {
            return [
                'BDLOGIC_RULE',
                'BDLOGIC_DD',
                'BDLOGIC_UI',
            ]
        },

        _getDefaultDataFields(map, node) {
            return {
                ...ComponentNode._getDefaultDataFields.call(this, map, node),
                resume: DEFAULT_RESUME,
                ruleType: 'BT',
                iterativeFlag: '1',
            }
        },

        _getShape(map, node) {
            return 'EllipseRectangle'
        },

        _getThemeColor(map, node) {
            if ('0' === node.data.iterativeFlag) {
                return Color.GREY
            }
            else {
                return ComponentNode._getThemeColor.call(this, map, node)
            }
        },

        async _onChange(map, node, event) {
            if (event.target === node) {
                const oldData = event.detail
                const {resume, ruleType} = node.data

                if (ruleType !== oldData.ruleType) {
                    map.forceRerenderChildren(node)

                    if (
                        'BL' === ruleType &&
                        DEFAULT_RESUME === resume
                    ) {
                        node.data = {...node.data, resume: ''}
                    }
                    else if ('' === resume) {
                        node.data = {...node.data, resume: DEFAULT_RESUME}
                    }
                }
            }

            await ComponentNode._onChange.call(this, map, node, event)
        },

        async _readGrowTree(map, node) {
            const tree = await map.BizNode.BDRULE._readGrowTree.call(
                this, map, node
            )

            for (const n of tree.children) {
                n.isFolded = true
            }

            return tree
        },
    })
}
